import { observer } from 'mobx-react-lite'
import { type BookkeepingManagerViewModel } from '@/features/admin/bookkeeping/BookkeepingManagerViewModel'
import { BookkeepingManagerTable } from '@/features/admin/bookkeeping/components/BookkeepingManagerTable'
import { BookkeepingManagerTableRowContainer } from '@/features/admin/bookkeeping/components/BookkeepingManagerTableRow/BookkeepingManagerTableRowContainer'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'

export interface BookkeepingManagerTableContainerProps {
  vm: BookkeepingManagerViewModel
}

export const BookkeepingManagerTableContainer = observer(
  function BookkeepingManagerTableContainer({
    vm,
  }: BookkeepingManagerTableContainerProps) {
    const table = () => (
      <BookkeepingManagerTable
        columns={vm.columns.map((col) => ({
          id: col.id,
          header: col.header,
          canSort: col.sortable,
          sortOrder: vm.getSortOrder(col),
        }))}
        onSort={vm.setSortOrder}
        loader={
          <InfiniteScrollLoaderContainer
            scrollProvider={vm.searcher.scroller}
          />
        }
      >
        {vm.items.map((itemVm) => (
          <BookkeepingManagerTableRowContainer
            key={itemVm.bookkeepingPendingAction.id}
            vm={itemVm}
            columnIds={vm.columnIds}
          />
        ))}
      </BookkeepingManagerTable>
    )

    return vm.searcher.scroller.fetch.match({
      // Realtime updates refetch in place, keeping the rows on screen.
      pending: () =>
        vm.searcher.scroller.isRevalidating ? table() : <ContentLoading />,
      rejected: (err) => <ContentError error={err} />,
      resolved: table,
    })
  },
)
